import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class TimeService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  listSchedule(query?: any) {
    return this.get('/v2/time/schedules', query);
  }

  createSchedule(body: any) {
    return this.post('/v2/time/create-schedule', body);
  }

  findSchedule(id) {
    return this.get('/v2/time/schedules/' + id);
  }

  updateSchedule(id, body) {
    return this.put('/v2/time/schedules/' + id, body);
  }

  deleteSchedule(id) {
    return this.delete('/v2/time/schedules/' + id);
  }

  listPeriod(query?: any) {
    return this.get('/v2/time/schedule-periods', query);
  }

  createPeriod(body: any) {
    return this.post('/v2/time/create-period', body);
  }

  findPeriod(id) {
    return this.get('/v2/time/schedule-periods/' + id);
  }

  updatePeriod(id, body) {
    return this.put('/v2/time/schedule-periods/' + id, body);
  }

  deletePeriod(id) {
    return this.delete('/v2/time/schedule-periods/' + id);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Time.service.ts